import { userPlaceholder } from "assets/icons";
import NotFound from "common/NotFound";
import { SearchBar } from "components/form";
import { CustomModal } from "components/modals/ModalBox";
import { limitOption } from "constants/staticData";
import { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import Pagination from "react-js-pagination";
import { Link, useSearchParams } from "react-router-dom";
import { firstWordCapital, getValueOrFallback } from "utils/common";
import findSerialNumber from "utils/findSerialNumber";
// import DeleteSelectedUser from "./DeleteSelectedUser";
import { CgBlock, CgUnblock } from "react-icons/cg";
// import ChangeSelectedUserStatus from "./ChangeSelectedUserStatus";
import PersonalDetails from "pages/personaldetails/PersonalDetails";
import DeleteSelectedUser from "pages/user-management/DeleteSelectedUser";
import { dateFormat } from "utils/dateFormat";
import SubAdminStatusManage from "./SubAdminStatusManage";
import { getSubAdminDetailsAPI, getSubAdminListAPI } from "services/subAdmin";
import { toast } from "sonner";
import moment from "moment";
import { MdModeEditOutline } from "react-icons/md";
import ViewPermissionAccess from "./ViewPermissionAccess";
import useDebounce from "common/UseDebounce";

const SubAdminList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isAddSubAdminModalOpen, setIsAddSubAdminModalOpen] = useState(false);
  const [isviewAccessModalOpen, setIsviewAccessModalOpen] = useState(false);

  const [total, setTotal] = useState(0);
  const [limits, setLimits] = useState(5);
  const [activePage, setActivePage] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const debouncedValue = useDebounce(searchValue, 300);

  const [subAdminListing, setSubAdminListing] = useState();
  const [subAdminDetails, setSubAdminDetails] = useState({ callRole: "add" });
  const [blockDetail, setBlockDetail] = useState(false);


  const [viewAccessPermissionList, setViewAccessPermissionList] = useState([]);

  console.log("I AM MODAL VISIBILITY", isBlockModalOpen);
  //************************* Handle HTML CODE ***********************//

  const handleLimit = () => { };
  const handlePageChange = () => { };

  // get sub-admin list handler
  const getSubAdminListHandler = async () => {
    try {
      const { data } = await getSubAdminListAPI(activePage, limits, debouncedValue?.length ? debouncedValue : "");
      console.log("I AM DATA", data);
      if (data?.success) {
        setSubAdminListing(data?.data);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getSubAdminListHandler();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    getSubAdminListHandler(activePage, limits);
  }, [searchParams, activePage, debouncedValue, limits]);

  // set subAdmin Details handler
  const setSubAdminDetailsHandler = async (subAdminId) => {
    try {
      const { data } = await getSubAdminDetailsAPI(subAdminId);
      console.log("I AM SUB ADMIN DETAILS", data);
      if (data?.success) {
        const detailsData = data?.data;
        const details = {
          callRole: "edit",
          _id: detailsData?._id,
          address: detailsData?.address,
          fullName: detailsData?.fullName,
          email: detailsData?.contact?.email,
          number: detailsData?.contact?.mobileNumber?.number,
          dialCode: detailsData?.contact?.mobileNumber?.dialCode,
          permissions: detailsData?.role?.resources?.map((el) => el),
        };

        setSubAdminDetails({ ...details });
        setIsAddSubAdminModalOpen(true);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title has_child">
          <h3>Sub-Admin Management</h3>
          <button
            type="button"
            className="button"
            onClick={() => {
              setSubAdminDetails({ callRole: "add" });
              setIsAddSubAdminModalOpen(true);
            }}
          >
            Add Sub-admin
          </button>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              value={searchValue}
              placeholder={
                "Search"
              }
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">ID</th>

                    <th className="nowrap text-center">Sub-Admin Name</th>
                    <th className="nowrap text-center">Registration Date</th>
                    <th className="nowrap text-center">Mobile Number</th>
                    <th className="nowrap text-center">Email</th>
                    <th className="nowrap text-center">Access to</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {loader}
                  {userList && userList.length ? (
                    userList?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="nowrap text-center">
                            {findSerialNumber(index, activePage, limits)}
                          </td>
                          <td className="nowrap text-center">
                            <img
                              src={
                                data?.profilePicture?.length &&
                                data?.profilePicture?.length > 50
                                  ? data?.profilePicture
                                  : userPlaceholder
                              }
                              alt="user-profile-image"
                              className="avatar"
                              onClick={() =>
                                showImagePreviewHandler(data?.profilePicture)
                              }
                            />
                          </td>
                          <td className="nowrap text-center text-capitalize">
                            {firstWordCapital(data?.fullName || "---")}
                          </td>
                          <td className="nowrap text-center">
                            {dateFormat(data?.createdAt)}
                          </td>
                          <td className="nowrap text-center">
                            {(data?.contact?.mobileNumber?.dialCode || "") +
                              "-" +
                              (data?.contact?.mobileNumber?.number || "---")}
                          </td>
                          <td className="nowrap text-center">
                            {getValueOrFallback(data?.contact?.email)}
                          </td>
                          <td
                            className="nowrap text-center"
                            style={{ textTransform: "capitalize" }}
                          >
                            {getValueOrFallback(
                              String(data?.status).toLowerCase()
                            )}
                          </td>
                          <td>
                            <div className="icon_wrap">
                              <Link
                                to={`user-detail/${data._id}`}
                                className="icon_button"
                              >
                                <FaEye />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  changeUserStatusHandler(data);
                                }}
                              >
                                {data.status === "ACTIVE" ? (
                                  <CgBlock style={{ color: "red" }} />
                                ) : (
                                  <CgUnblock />
                                )}
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={10}
                      msg={"User Data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody> */}

                <tbody>
                  {subAdminListing?.length > 0 &&
                    subAdminListing?.map((el, i) => (
                      <tr key={el?._id}>
                        <td className="nowrap text-center">
                          {el?.id || i + 1}
                        </td>
                        <td className="nowrap text-center text-capitalize">
                          {el?.fullName}
                        </td>
                        <td className="nowrap text-center">
                          {moment(el?.createdAt).format("D/MM/YYYY")}
                        </td>
                        <td className="nowrap text-center">{`${el?.contact?.mobileNumber?.number}`}</td>
                        <td className="nowrap text-center">
                          {el?.contact?.email || "-----"}
                        </td>

                        <td
                          className="nowrap text-center"
                          style={{ textTransform: "capitalize" }}
                        >
                          {el?.role?.resources.join(", ").substr(0, 25)} ......
                          <span
                            style={{ color: "blue" }}
                            onClick={() => {
                              setViewAccessPermissionList(el?.role?.resources);
                              setIsviewAccessModalOpen(true);
                            }}
                          >
                            read more
                          </span>
                        </td>
                        <td>
                          {/* <div className="icon_wrap">
                        <Link
                          // to={`user-detail/${data._id}`}
                          className="icon_button"
                        >
                          <FaEye />
                        </Link>
                        <Link
                          to=""
                          className="icon_button"
                          onClick={(e) => {
                            e.preventDefault();
                            changeUserStatusHandler(data);
                          }}
                        >
                          {data.status === "ACTIVE" ? (
                            <CgBlock style={{ color: "red" }} />
                          ) : (
                            <CgUnblock />
                          )}
                        </Link>
                      </div> */}

                          <div className="icon_wrap">
                            <button
                              className="icon_button"
                              onClick={() => setSubAdminDetailsHandler(el?._id)}
                            >
                              <MdModeEditOutline />
                            </button>
                            <button
                              className="icon_button"
                              onClick={() => {
                                setIsBlockModalOpen(true)
                                setBlockDetail(el);
                              }}
                            >
                              {el.status === "ACTIVE" ? (
                                <CgBlock style={{ color: "red" }} />
                              ) : (
                                <CgUnblock />
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limits}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete User */}
      {/* {deleteModel && (
        <DeleteSelectedUser
          selectedUserDetail={selectedUserDetail}
          onClose={() => onClose()}
          setUserList={setUserList}
          deleteModel={deleteModel}
        />
      )} */}

      {/* Change Admin Status Modal*/}
      {isBlockModalOpen && (
        <SubAdminStatusManage
          isBlockModalVisible={isBlockModalOpen}
          selectedUserDetail={blockDetail}
          onClose={() => setIsBlockModalOpen(false)}
          refetchUserList={() => getSubAdminListHandler()}
        />
      )}

      {/* View Sub-Admin Permission Access model */}
      <CustomModal
        className={"lg"}
        show={isviewAccessModalOpen}
        handleClose={() => {
          setIsviewAccessModalOpen(false);
        }}
      >
        <ViewPermissionAccess accessPermissionData={viewAccessPermissionList} />
      </CustomModal>

      {/* Add Sub-Admin model */}
      <CustomModal
        className={"lg"}
        show={isAddSubAdminModalOpen}
        handleClose={() => {
          setIsAddSubAdminModalOpen(false);
        }}
      >
        <PersonalDetails
          detailsData={subAdminDetails}
          getListHandler={getSubAdminListHandler}
          setSubAdminModal={setIsAddSubAdminModalOpen}
        />
      </CustomModal>
    </>
  );
};

export default SubAdminList;
